module.exports = __webpack_public_path__ + "static/ethan-small-3437089c2de6aac212d747781e007d54.webp";